// extracted by mini-css-extract-plugin
module.exports = {"removable":"Removable__removable__ANdtT","button":"Removable__button__0-jWi"};